import { Button, Text } from "@fluentui/react-components";
import { useState } from "react";
import { ErrorScreenImage } from "../../../assets";
import { IErrorScreenProps } from "../../../hooks/types";
import { appSupportedConstants, errorScreensGlowImagesConstants } from "../../../utility/app-constants";
import { RandomGlowImage } from "../../../utility/app-utilities";

/**
 * Application level Error Screen
 * @returns 
 */
export default function ErrorScreen(props: IErrorScreenProps) {
    const [glowImage] = useState(RandomGlowImage(errorScreensGlowImagesConstants.glowImage as []));
    return (
        <div className="error-screen-main" data-testid="error-screen-main">
            <div className="error-screen-container">
                <img className="error-glow-img" src={glowImage} alt="glow_image" />
                <img className="error-image" src={ErrorScreenImage} alt="Error Screen_Image" />
                <Text className="error-text" weight="semibold" size={600}>{props.title}</Text>
                <Text className="error-text-refresh" weight="semibold" size={500}>{props.subTitle}</Text>
                {props.errorCode ? <Text className="error-text-code" weight="regular">{appSupportedConstants.errorCodeText} {props.errorCode}</Text> : props.errorCode}
                {props.refreshButton && <Button className="refresh-button" appearance="primary" onClick={() => window.location.reload()} data-testid="refresh-btn">{appSupportedConstants.refreshButtonText}</Button>}
            </div>
        </div>
    );
}
